export default {
  noReviewsText1: {
    id: 'seller_page_no_reviews_text_1',
    defaultMessage: "We're looking for reviews",
  },
  noReviewsText2: {
    id: 'seller_page_no_reviews_text_2',
    defaultMessage: 'No reviews yet, but you could be the first.',
  },
} as const
